<script>
import cloneDeep from 'lodash/cloneDeep';
import Layout from '@layouts/main.vue';
import Sidebar from '@components/sidebar/sidebar.vue';
import UseLargeScreen from '@components/use-large-screen.vue';
import { breakpointsMixin } from '@mixins/breakpoints-mixin.js';

import {
  authComputed,
  nutritionComputed,
  nutritionMethods,
  platelistComputed,
  platelistMethods,
  recipeComputed,
  recipeMethods,
} from '@state/helpers';

export default {
  page: {
    title: 'Nutrition',
    meta: [{ name: 'description', content: 'The Nutrition page.' }],
  },
  components: {
    Layout,
    Sidebar,
    UseLargeScreen,
  },
  mixins: [breakpointsMixin],
  data() {
    return {
      displayLimit: 0,
      initialDisplayLimit: 4,
      maxScrollTop: 0,
      publicationStatusOpts: [
        { id: 1, label: 'Archived', value: 'archived' },
        { id: 2, label: 'Drafted', value: 'draft' },
        { id: 3, label: 'Published', value: 'published' },
      ],
      selectedFilters: [],
      filters: {
        library: [],
        status: [],
      },
      selectedTrainerRecipeLibrary: false,
      selectedOrgRecipeLibrary: false,
      selectedMealPlanLibraries: [],
      visibleOptsCount: 5,
      visibleDietOptsCount: null,
      visibleHealthOptsCount: null,
      visibleTagOptsCount: null,
      libraryOpts: [
        {
          label: 'My Library',
          id: 0,
        },
        {
          label: this.$store.getters['organization/organizationTitle'],
          id: 1,
        },
      ],
    };
  },
  computed: {
    ...authComputed,
    ...nutritionComputed,
    ...platelistComputed,
    ...recipeComputed,
    platelistFilterComputed() {
      return this.platelistFilter;
    },
    isTrainer() {
      return (
        this.currentUser &&
        this.currentUser.roles &&
        this.currentUser.roles.isTrainer
      );
    },
    isChildRecipesView() {
      return this.$route.name && this.$route.name === 'recipes';
    },
    isChildMealPlansView() {
      return this.$route.name && this.$route.name === 'mealPlans';
    },
    recipeMealtimeOpts() {
      return (
        this.recipeFilterOpts &&
        this.recipeFilterOpts['Meal Time Requirements'] &&
        this.recipeFilterOpts['Meal Time Requirements'].options
      );
    },
    recipeDietOpts() {
      return (
        this.recipeFilterOpts &&
        this.recipeFilterOpts['Diet Requirements'] &&
        this.recipeFilterOpts['Diet Requirements'].options
      );
    },
    recipeHealthOpts() {
      return (
        this.recipeFilterOpts &&
        this.recipeFilterOpts['Health Requirements'] &&
        this.recipeFilterOpts['Health Requirements'].options
      );
    },
    recipeTypeOpts() {
      return (
        this.recipeFilterOpts &&
        this.recipeFilterOpts['Recipe Type'] &&
        this.recipeFilterOpts['Recipe Type'].options
      );
    },
    recipeTagOpts() {
      return (
        this.recipeFilterOpts &&
        this.recipeFilterOpts['Tag Requirements'] &&
        this.recipeFilterOpts['Tag Requirements'].options
      );
    },
  },
  beforeMount() {
    this.visibleDietOptsCount = this.visibleOptsCount;
    this.visibleHealthOptsCount = this.visibleOptsCount;
    this.visibleTagOptsCount = this.visibleOptsCount;
  },
  mounted() {
    this.displayLimit = this.initialDisplayLimit;
    this.setSelectedRecipeFilterOpts('reset');
    if (this.platelistFilter && this.isChildMealPlansView) {
      for (const filterName in this.platelistFilter) {
        this.filters[filterName] = cloneDeep(this.platelistFilter[filterName]);
      }
    }

    if (this.recipesFilter && this.isChildRecipesView) {
      for (const filterName in this.recipesFilter) {
        this.filters[filterName] = cloneDeep(this.recipesFilter[filterName]);
      }
    }

    this.allRecipesSource = cloneDeep(this.allRecipes.hits);
  },
  methods: {
    ...nutritionMethods,
    ...platelistMethods,
    ...recipeMethods,
    onScroll() {
      let scrollContainer = null;
      const recipesPerRow = 1;
      scrollContainer = this.$el.getElementsByClassName('content-wrapper')[0];
      const scrollTop = scrollContainer.scrollTop;

      if (this.maxScrollTop < scrollTop) {
        this.maxScrollTop = scrollTop;
      }

      const additionalCards = Math.floor(
        (this.maxScrollTop * recipesPerRow) / 200
      );
      this.displayLimit = this.initialDisplayLimit + additionalCards;
    },
    optsCount(group) {
      switch (group) {
        case 'dietOpts':
          return this.recipeDietOpts
            ? Object.keys(this.recipeDietOpts).length
            : 0;
        case 'healthOpts':
          return this.recipeHealthOpts
            ? Object.keys(this.recipeHealthOpts).length
            : 0;
        case 'tagOpts':
          return this.recipeTagOpts
            ? Object.keys(this.recipeTagOpts).length
            : 0;
      }
    },
    showAllOpts(group) {
      switch (group) {
        case 'dietOpts':
          this.visibleDietOptsCount === this.visibleOptsCount
            ? (this.visibleDietOptsCount = this.optsCount(group))
            : (this.visibleDietOptsCount = this.visibleOptsCount);
          break;
        case 'healthOpts':
          this.visibleHealthOptsCount === this.visibleOptsCount
            ? (this.visibleHealthOptsCount = this.optsCount(group))
            : (this.visibleHealthOptsCount = this.visibleOptsCount);
          break;
        case 'tagOpts':
          this.visibleTagOptsCount === this.visibleOptsCount
            ? (this.visibleTagOptsCount = this.optsCount(group))
            : (this.visibleTagOptsCount = this.visibleOptsCount);
          break;
        default:
          break;
      }
    },
    onSelectFilter(val, group = null) {
      if (this.isChildMealPlansView) {
        this.handleMealPlanFilters(val);
      } else if (this.isChildRecipesView) {
        this.handleRecipeFilters(val, group);
      }
    },
    // This could probably be refactored to be more succinct 😳
    async handleRecipeFilters(opt, group) {
      this.setIsLoadingRecipes(true);
      if (!opt.target) {
        await this.setSelectedRecipeFilterOpts({ opt, group });
        await this.getAllRecipes();
        /* this.selectedTrainerRecipeLibrary
            ? this.setFilterTrainerOnlyRecipes(true)
            : this.setFilterTrainerOnlyRecipes(false); */
      }
      this.setIsLoadingRecipes(false);
    },
    handleClearSelectedFilters() {
      for (const filterName in this.filters) {
        this.filters[filterName] = [];
      }
      if (this.$refs && this.$refs.checkBox) {
        this.$refs.checkBox.forEach((checkBox) => {
          checkBox.$el.children[0].firstChild.checked = false;
        });
      }
    },
  },
  watch: {
    filters: {
      deep: true,
      handler: function(newValue) {
        const filterValue = cloneDeep(newValue);
        if (this.isChildRecipesView) {
          this.setRecipesFilter(filterValue);
        } else if (this.isChildMealPlansView) {
          this.setPlateListFilter(filterValue);
        }
      },
    },
    selectedFilters(newVal, oldVal) {
      if (newVal && newVal.length === 1 && newVal.includes('archived')) {
        if (this.isChildRecipesView) {
          this.setShowRecipeArchivedOverlay(false);
        } else if (this.isChildMealPlansView) {
          this.setShowPlatelistArchivedOverlay(false);
        }
      } else {
        if (this.isChildRecipesView) {
          this.setShowRecipeArchivedOverlay(true);
        } else if (this.isChildMealPlansView) {
          this.setShowPlatelistArchivedOverlay(true);
        }
      }
    },
    clearRecipeFilters(newVal, oldVal) {
      this.handleClearSelectedFilters();
    },
    clearMealPlanFilters(newVal, oldVal) {
      this.handleClearSelectedFilters();
    },
  },
};
</script>

<template>
  <UseLargeScreen v-if="isSmallScreenView" />
  <Layout v-else>
    <div class="container-wrapper dark">
      <Sidebar type="light">
        <div class="sidebar-section">
          <ul>
            <li class="sidebar-nav-list-item">
              <router-link :to="{ name: 'mealPlans' }">
                <span class="link-text-wrapper">
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'sidebar-list-icon icon-cal-alt'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.4 0v1.2H3.6V0H2.4v1.2h-.6c-.666 0-1.194.54-1.194 1.2L.6 10.8c0 .66.534 1.2 1.2 1.2h8.4c.66 0 1.2-.54 1.2-1.2V2.4c0-.66-.54-1.2-1.2-1.2h-.6V0H8.4zM9 6.6H6v3h3v-3zm-7.2 4.2h8.4V4.2H1.8v6.6z" fill="#fff"/></svg>
                  <span>Meal Plans</span>
                </span>
              </router-link>
            </li>
            <li class="sidebar-nav-list-item">
              <router-link :to="{ name: 'recipes' }">
                <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'sidebar-list-icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.15 7.15c-1.59 1.59-3.74 2.09-5.27 1.38L11.41 10l6.88 6.88-1.41 1.41L10 11.41l-6.89 6.87-1.41-1.41 9.76-9.76c-.71-1.53-.21-3.68 1.38-5.27 1.92-1.91 4.66-2.27 6.12-.81 1.47 1.47 1.1 4.21-.81 6.12zm-9.22.36L6.1 10.34 1.91 6.16a4.008 4.008 0 010-5.66l7.02 7.01z" fill="#000"/></svg>
                <span>Recipes</span>
              </router-link>
            </li>
          </ul>
        </div>

        <h5 class="sidebar-section-title">
          <span v-if="isChildRecipesView">Filter Recipes</span>
          <span v-if="isChildMealPlansView">Filter Meal Plans</span>
        </h5>

        <!-- SHARED FILTERS -->

        <div class="sidebar-section" v-if="isTrainer">
          <div class="sidebar-section-container">
            <legend class="sidebar-subtitle">Library</legend>
            <div class="sidebar-section-container">
              <BaseCheckboxModel
                ref="library_checkBox"
                itemRef="libarary_checkbox"
                v-for="(item, i) in libraryOpts"
                :item="item"
                :itemIndex="i"
                :key="i"
                :keepSameLabel="true"
                :value="item.id"
                v-model="filters.library"
              />
            </div>
          </div>
        </div>

        <div class="sidebar-section">
          <div class="sidebar-section-container">
            <legend class="sidebar-subtitle">Publication Status</legend>
            <div class="sidebar-section-container">
              <BaseCheckboxModel
                ref="status_checkBox"
                itemRef="publish_status_checkbox"
                v-for="(item, i) in publicationStatusOpts"
                :item="item"
                :itemIndex="i"
                :key="i"
                :value="item.value"
                v-model="filters.status"
              />
            </div>
          </div>
        </div>

        <!-- RECIPE FILTERS -->

        <div
          class="sidebar-section"
          v-if="recipeFilterOpts && isChildRecipesView"
        >
          <div class="sidebar-section-container">
            <legend class="sidebar-subtitle">Common Tags</legend>
            <div class="sidebar-section-container">
              <BaseCheckbox
                ref="checkBox"
                v-for="(item, i) in recipeTagOpts"
                :item="item"
                :itemIndex="i"
                :key="i"
                @change="onSelectFilter(item, 'Tag Requirements')"
              />
            </div>
          </div>
        </div>

        <div
          class="sidebar-section"
          v-if="recipeFilterOpts && isChildRecipesView"
        >
          <div class="sidebar-section-container">
            <legend class="sidebar-subtitle">Meal Times</legend>
            <div class="sidebar-section-container">
              <BaseCheckbox
                ref="checkBox"
                v-for="(item, i) in recipeMealtimeOpts"
                :item="item"
                :itemIndex="i"
                :key="i"
                :style="
                  `display: ${
                    parseInt(i) + 1 > visibleDietOptsCount
                      ? 'none'
                      : 'inline-flex'
                  }`
                "
                @change="onSelectFilter(item, 'Meal Time Requirements')"
              />
            </div>
          </div>
        </div>

        <div
          class="sidebar-section"
          v-if="recipeFilterOpts && isChildRecipesView"
        >
          <div class="sidebar-section-container">
            <legend class="sidebar-subtitle">Diets</legend>
            <div class="sidebar-section-container">
              <BaseCheckbox
                ref="checkBox"
                v-for="(item, i) in recipeDietOpts"
                :item="item"
                :itemIndex="i"
                :key="i"
                :style="
                  `display: ${
                    parseInt(i) + 1 > visibleDietOptsCount
                      ? 'none'
                      : 'inline-flex'
                  }`
                "
                @change="onSelectFilter(item, 'Diet Requirements')"
              />
            </div>
            <a
              class="link-more"
              v-if="optsCount('dietOpts') > visibleOptsCount"
              @click="showAllOpts('dietOpts')"
            >
              <span v-if="visibleDietOptsCount === visibleOptsCount"
                >More...</span
              >
              <span v-else>Less...</span>
            </a>
          </div>
        </div>

        <div
          class="sidebar-section"
          v-if="recipeFilterOpts && isChildRecipesView"
        >
          <div class="sidebar-section-container">
            <legend class="sidebar-subtitle">Lifestyles</legend>
            <div class="sidebar-section-container">
              <BaseCheckbox
                ref="checkBox"
                v-for="(item, i) in recipeHealthOpts"
                :item="item"
                :itemIndex="i"
                :key="i"
                :style="
                  `display: ${
                    parseInt(i) + 1 > visibleHealthOptsCount
                      ? 'none'
                      : 'inline-flex'
                  }`
                "
                @change="onSelectFilter(item, 'Health Requirements')"
              />
            </div>
            <a
              class="link-more"
              v-if="optsCount('healthOpts') > visibleOptsCount"
              @click="showAllOpts('healthOpts')"
            >
              <span v-if="visibleHealthOptsCount === visibleOptsCount"
                >More...</span
              >
              <span v-else>Less...</span>
            </a>
          </div>
        </div>
      </Sidebar>

      <div class="content-wrapper no-pad" @scroll="onScroll">
        <router-view :displayLimit="displayLimit"></router-view>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" scoped>
@import '@design';

.sidebar-section-container {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: center;

  a {
    color: $color-gray;
    font-size: 1.1rem;
    margin-left: 2.4rem;
  }
}

.sidebar-section {
  .sidebar-nav-list-item {
    margin-bottom: 1rem;
    position: relative;

    &:hover {
      cursor: pointer;
    }

    .link-text-wrapper {
      position: relative;
    }

    .sidebar-list-icon {
      margin-right: 1rem;

      &.icon-cal-alt {
        height: 2rem;
        width: 2.4rem;

        path {
          fill: black;
        }
      }
    }

    a {
      color: $color-medium-gray-alt;
      font-size: 1.4rem;
      font-weight: 600;
      letter-spacing: 0.116667px;
      line-height: 2.2rem;
      text-decoration: none;

      &.router-link-exact-active {
        color: $color-heading-text;

        &::after {
          background-color: $color-action;
          content: '';
          display: block;
          height: 100%;
          position: absolute;
          right: -2rem;
          top: 0;
          width: 0.9rem;
        }
      }
    }
  }
}

.sidebar-section-title {
  color: $color-heading-text;
  font-family: $base-font-family;
  font-size: 1.2rem;
  font-weight: 900;
  letter-spacing: 0.1px;
  line-height: 2.2rem;
  margin-bottom: 1rem;
  text-transform: uppercase;

  &.child-meal-plan-view {
    display: none;
  }
}

// stylelint-disable selector-max-type
label {
  position: relative;
}

.check-box-title {
  font-family: $base-font-family;
  font-size: 1.1rem;
  font-weight: 900;
  letter-spacing: 0.2px;
  line-height: 2rem;
  margin-left: 7px;
  text-transform: capitalize;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.type-opts-container {
  display: inline-flex;
  justify-content: center;
  margin-bottom: 0.5rem;

  label {
    margin-bottom: 0.2rem;
  }
}

.check-box {
  background-color: $color-light-gray;
  border-radius: 10%;
  cursor: pointer;
  display: inline-block;
  height: 14px;
  transition: all linear 0.3s;
  width: 14px;

  &::after {
    border-bottom: 2px solid $color-tag-text;
    border-right: 2px solid $color-tag-text;
    content: '';
    height: 9px;
    left: 5px;
    opacity: 0.6;
    position: absolute;
    top: 2.5px;
    transform: rotate(45deg);
    visibility: hidden;
    width: 5px;
  }
}

input {
  display: none;

  &:checked ~ .check-box {
    background: $color-yellow;
    border: unset;

    &::after {
      visibility: visible;
    }
  }
}

.input-filter {
  text-align-last: center;
}
</style>
